

import { TableColumnDef } from "@app/shared/components/smart-data-grid/data-grid/data-grid.constants";
import { DropDownItem, GenerateDropDownItems, SearchByItem } from "@app/shared/classes/general";
import { smartSearchType } from "@app/shared/components/smart-search-form/smart-search-form.constant";
import { Status } from "@app/shared/enums";
import { CountryCodeTranslate } from "@app/shared/pipes/country-code-translate";
import { SubRegion } from "@app/shared/classes/subRegion";
import { BusinessHelper } from "@app/shared/utils/business-helper";

enum FieldLabel {
  TERMINAL_NAME = "ml_143910",
  SUB_REGION = "ml_143911",
  COUNTRY = "ml_143912",
  KPI_NAME = "ml_143913",
  YEAR_AND_MONTH = "ml_143914",
  COMPLANCE = "ml_143915",
  CREATED_BY = "ml_143916",
  CREATED_ON = "ml_143917",
  LAST_CHANGED_BY = "ml_143918",

  LINE_NUMBER = "ml_143953",
  IMPORT_FAILED_MESSAGE = "ml_143954",

  DRIVER_APEX_ID = "ml_143930",
  DRIVER_EMPLOYEE_ID = "ml_144069",
  DRIVER_NAME = "ml_143908",
  TERMINAL = "ml_144113",
  TERMINAL_ID = "ml_143909",
  BUSINESS_TYPE = "ml_144070",
  EMPLOYEE_OR_3PL = "ml_144071",
  STATUS = "ml_144072",
  LAST_CHANGED_ON = "ml_143919",
  INACTIVE = "ml_144081"
}

export enum DriverDataFieldName {
  driverName = "driverName",
  terminalId = "terminalId",
  terminalName = "terminalName",
  subRegionName = "subRegionName",
  country = "country",
  kpiName = "kpiName",
  kpiDate = "kpiDate",
  compliance = "compliance",
  created_On = "created_On",
  created_By = "created_By",
  lastModified_By = "lastModified_By",
  lastModified_On = "lastModified_On",

  rowNum = "rowNum",
  errorMessage = "errorMessage",

  apexId = "apexId",
  employeeId = "employeeId",
  fullName = "fullName",
  terminal = "terminal",
  businessType = "businessType",
  employeeOr3PL = "employeeOr3PL",
  status = "status"
};

export const DataGridColumnDef: TableColumnDef[] = [
  {
    text: FieldLabel.DRIVER_APEX_ID,
    name: DriverDataFieldName.apexId,
    sort: true
  },
  {
    text: FieldLabel.DRIVER_EMPLOYEE_ID,
    name: DriverDataFieldName.employeeId,
    sort: true
  },
  {
    text: FieldLabel.DRIVER_NAME,
    name: DriverDataFieldName.fullName,
    sort: true
  },
  {
    text: FieldLabel.TERMINAL_ID,
    name: DriverDataFieldName.terminalId,
    sort: true
  },
  {
    text: FieldLabel.TERMINAL_NAME,
    name: DriverDataFieldName.terminalName,
    sort: true
  },
  {
    text: FieldLabel.SUB_REGION,
    name: DriverDataFieldName.subRegionName,
    sort: true,
  },
  {
    text: FieldLabel.COUNTRY,
    name: DriverDataFieldName.country,
    sort: true,
    pipe: CountryCodeTranslate
  },
  {
    text: FieldLabel.BUSINESS_TYPE,
    name: DriverDataFieldName.businessType,
    sort: true
  },
  {
    text: FieldLabel.EMPLOYEE_OR_3PL,
    name: DriverDataFieldName.employeeOr3PL,
    sort: true
  },
  {
    text: FieldLabel.INACTIVE,
    name: DriverDataFieldName.status,
    sort: true
  }
];

export const GetDriverDataSearchByList = ([terminals, subRegions]: [DropDownItem[], SubRegion[]]) => {
  var result = DriverDataSearchByList.slice();
  result[3].searchDropDownValue = terminals;
  result[4].searchDropDownValue = subRegions ? GenerateDropDownItems(subRegions.map(item => item.subRegionName)) : [];
  return result;
}

export const complianceSelectItems = [{ value: true, label: "ml_143931" }, { value: false, label: "ml_143932" }];
export const employeeOr3plSelectItems = [{ value: "Employee", label: "Employee" }, { value: "3PL", label: "3PL" }];
export const statusSelectItems = [{ value: "A", label: "Active" }, { value: "I", label: "Inactive" }];

const DriverDataSearchByList: SearchByItem[] = [
  { searchBy: DriverDataFieldName.apexId, searchByLabel: FieldLabel.DRIVER_APEX_ID },
  {
    searchBy: DriverDataFieldName.employeeId, searchByLabel: FieldLabel.DRIVER_EMPLOYEE_ID,
  },
  { searchBy: DriverDataFieldName.fullName, searchByLabel: FieldLabel.DRIVER_NAME },
  { searchBy: DriverDataFieldName.terminalId, searchByLabel: FieldLabel.TERMINAL, searchByType: smartSearchType.multipleSelect, searchDropDownValue: [] },
  { searchBy: DriverDataFieldName.subRegionName, searchByLabel: FieldLabel.SUB_REGION, searchByType: smartSearchType.multipleSelect, searchDropDownValue: [] },
  {
    searchBy: DriverDataFieldName.businessType, searchByLabel: FieldLabel.BUSINESS_TYPE, searchByType: smartSearchType.multipleSelect,
    searchDropDownValue: BusinessHelper.GetSeperatedBusinessTypeDropDownList()
  },
  {
    searchBy: DriverDataFieldName.employeeOr3PL, searchByLabel: FieldLabel.EMPLOYEE_OR_3PL, searchByType: smartSearchType.multipleSelect,
    searchDropDownValue: employeeOr3plSelectItems
  },
  {
    searchBy: DriverDataFieldName.status, searchByLabel: FieldLabel.INACTIVE, searchByType: smartSearchType.multipleSelect,
    searchDropDownValue: [{ value: Status.INACTIVE, label: "ml_143931" }, { value: Status.ACTIVE, label: "ml_143932" }]
  }
];
